import { doLogout } from "views/Login/actions"
import { TOKEN_KEY, BASE_URL } from 'constant'

export default function privateFetch(success, error, loading, method, url, body) {

  return (dispatch) => {
    dispatch(success(false, null))
    dispatch(error(false))
    dispatch(loading(true))

    let token = localStorage.getItem(TOKEN_KEY) || null
    let config = {}
    config = {
      method: method,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    }
    if (body) config.body = JSON.stringify(body)

    fetch(url, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout())
        }

        dispatch(loading(false))
        if (!response.ok) {
          throw Error(response.statusText)
        }
        return response
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          dispatch(success(true, data))
        } else {
          dispatch(error(true))
        }
      })
      .catch((err) => {
        dispatch(error(true))
      })
  }
}

export function privateFetchWithMessage(success, error, loading, method, url, body) {

  return (dispatch) => {
    dispatch(success(false, null))
    dispatch(error(false, ''))
    dispatch(loading(true))

    let token = localStorage.getItem(TOKEN_KEY) || null
    let config = {}
    config = {
      method: method,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    }
    if (body) config.body = JSON.stringify(body)

    fetch(url, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout())
        }

        dispatch(loading(false))
        if (!response.ok) {
          throw Error(response.statusText)
        }
        return response
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          dispatch(success(true, data))
        } else {
          dispatch(error(true, data.message))
        }
      })
      .catch((err) => {
        dispatch(error(true, 'Silahkan mencoba beberapa saat lagi, pastikan anda terkoneksi dengan internet'))
      })
  }
}

export function privateFetchFormData(success, error, loading, method, url, body) {
  return (dispatch) => {
    dispatch(success(false, null))
    dispatch(error(false))
    dispatch(loading(true))

    let token = localStorage.getItem(TOKEN_KEY) || null

    let formData = new FormData();
    for (var key in body) {
      if (Array.isArray(body[key])) {
        for (var d in body[key]) {
          var o = Object.keys(body[key][d]);
          for (var s in o) {

            formData.append(`${key}[${d}][${o[s]}]`, body[key][d][o[s]])
          }
        }

      } else {

        formData.append(key, body[key])
      }
    }

    let config = {}
    config = {
      method: method,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': 'Content-Type, Origin, Authorization'
      },
      body: formData
    }

    fetch(url, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout())
        }

        dispatch(loading(false))
        if (!response.ok) {
          throw Error(response.statusText)
        }

        return response
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          dispatch(success(true, data))
        } else {
          dispatch(error(true))
        }
      })
      .catch((err) => {
        dispatch(error(true))
      })
  }
}
